var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import APUpload from '../APUpload/APUpload';
import '../APUpload/APUpload.css';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import { maxFileSize } from '../../../helpers/formValidations';
var baseClass = 'ap-image-upload';
var APDocumentUpload = function (_React$Component) {
  _inherits(APDocumentUpload, _React$Component);
  function APDocumentUpload() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, APDocumentUpload);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = APDocumentUpload.__proto__ || Object.getPrototypeOf(APDocumentUpload)).call.apply(_ref, [this].concat(args))), _this), _this.maxSize = function (value) {
      var maxSize = _this.props.maxSize;
      if (maxSize) return maxFileSize(value, maxSize);
    }, _this.getValidators = function () {
      var validate = _this.props.validate;
      return validate ? [].concat(_toConsumableArray(validate), [_this.maxSize]) : [_this.maxSize];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(APDocumentUpload, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        customClass = _props.customClass,
        otherProps = _objectWithoutProperties(_props, ['customClass']);
      var bemClasses = getBEMClasses(baseClass, customClass);
      return React.createElement(APUpload, Object.assign({}, otherProps, {
        customClass: bemClasses(),
        acceptedFiles: '.pdf, .doc, .docx',
        validate: this.getValidators()
      }));
    }
  }]);
  return APDocumentUpload;
}(React.Component);
APDocumentUpload.defaultProps = {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: ''
};
APDocumentUpload.propTypes = {
  name: PropTypes.string,
  customClass: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool
};
APDocumentUpload.contextTypes = {
  t: PropTypes.func.isRequired
};
APDocumentUpload.defaultProps = {
  name: '',
  label: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  maxSize: null
};
APDocumentUpload.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  customClass: PropTypes.string,
  classModifiers: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  placeholder: PropTypes.string,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  autoFocus: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool
};
export default APDocumentUpload;